export const setRoundsPlayed = (state, payload) => {
  state.sharkRounds.filter = payload.filter;
  payload.data.data.get.sort((a, b) => b.end_time.toString().localeCompare(a.end_time.toString()));
  state.sharkRounds.rawData = payload.data.data.get;
};
export const setSharkScreensData = (state, payload) => {
  state.sharkScreens.filter = payload.filter;
  state.sharkScreens.rawData = payload.data;
};
export const setSharkAllGroups = (state, payload) => {
  state.sharkAllGroups = payload;
};
export const setSharkGroupsData = (state, payload) => {
  state.sharkGroups.filter = payload.filter;
  state.sharkGroups.rawGroupsData = payload.groups;
  // payload.rounds.sort((a, b) =>
  //   b.end_time.toString().localeCompare(a.end_time.toString())
  // );
  state.sharkGroups.rawRoundsData = payload.rounds;
};
export const setSharkAnalyticsData = (state, payload) => {
  state.sharkAnalyticsData = payload;
};
export const setSharkUniqueRentalData = (state, payload) => {
  state.sharkUniqueRentalData = payload;
};
